import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import { Table, type TableProps } from "antd";
import { Icon } from "@iconify/react";
import ButtonIcon from "../../components/ButtonIcon";
import StatusVisit from "../../components/StatusVisit";
import { numberFormatterLabel } from "../../helper/method";
import { $api, type components } from "../../helper";
import { useNotify } from "../../helper/notify";
import { statusMock, tokenMock } from "../../helper/mock";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function ShippingMethod() {
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState<string>("");
  const notify = useNotify();
  const { mutate, isPending } = $api.useMutation(
    "delete",
    `/site-api/v1/shipping/`,
  );
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/shipping/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("روش های ارسال");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteShippingItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "نام روش ارسال",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "قیمت روش ارسال",
      dataIndex: "price",
      key: "price",
      render: (_, record) => <span>{numberFormatterLabel(record.price)}</span>,
    },
    {
      title: "ترتیب نمایش",
      dataIndex: "display_order",
      key: "display_order",
    },
    {
      title: "نمایش در سایت",
      key: "status",
      dataIndex: "status",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
            to={{
              pathname: "/add-shipping-method",
              search: `?u_id=${record.u_id}`,
            }}
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            className="text-primary-500!"
            to={{
              pathname: "/add-shipping-method",
              search: `?u_id=${record.u_id}`,
            }}
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={isPending}
        title="حذف از دسته بندی ها ؟"
        description="حذف این دسته‌بندی باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          mutate(
            {
              params: {
                query: {
                  shipping_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setId("");
                setIsOpen(false);
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
      <div className="w-full flex justify-end sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link to={"/add-shipping-method"} className="button-style">
          ایجاد روش ارسال
        </Link>
      </div>
      <div>
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SiteShippingItem"]>
              columns={columns}
              className="col-span-1!"
              scroll={{ x: "max-content" }}
              dataSource={data?.data}
              loading={isLoading}
              rowKey="id"
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
